<template>
  <!-- <div
    class="jumbotron no_space dmbs-container"
  > -->
  <v-container class="pa-0 contenedor">
    <template>
      <v-navigation-drawer
        class="hidden-sm-and-up"
        v-model="menuMovil"
        app
      >
        <v-list>
          <v-list-tile :to="`/${$i18n.locale}/`">
            <v-list-tile-title><i class="fa fa-home"></i> {{$t('Inicio')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-group
            no-action
            sub-group
            value="false"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title> {{$t('Categorías')}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-for="(item, index) in categorias"
              :key="index"
              :to="`/${$i18n.locale}/cat/${item.id}`"
            >
              <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
            sub-group
            value="false"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title> {{$t('Consultas de Entradas')}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="`/${$i18n.locale}/mis-operaciones`">
              <v-list-tile-title>{{$t(consultasEntradas[0].nombre)}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              :href="entradasUrl"
              target="_blank"
            >
              <v-list-tile-title>{{$t(consultasEntradas[1].nombre)}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="`/${$i18n.locale}/como-comprar`">
              <v-list-tile-title>{{$t(consultasEntradas[2].nombre)}}</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-group
            no-action
            sub-group
            value="false"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title> {{$t('Eventos')}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in provincias"
              :key="index"
              :to="`/${$i18n.locale}/loc/${item.id}`"
            >
              <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
            sub-group
            value="false"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title> {{$t('Recintos')}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in recintos"
              :key="index"
              :to="`/${$i18n.locale}/recintos/${item.id}`"
            >
              <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list>

      </v-navigation-drawer>
    </template>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <v-progress-linear
      :color="colorDestacado"
      height="3"
      :indeterminate="true"
      v-if="cargando"
      class="mt-0"
    >
    </v-progress-linear>
    <Anuncio v-if="componenteAnuncio" />
    <Cabecera />
    <Menu />
    <transition
      :name="tipoTransicion"
      mode="out-in"
    >
      <router-view />
      
    </transition>
    <lanzar-cookie></lanzar-cookie>
    <intro-popup v-if="popup"></intro-popup>
    <Pie v-if="$store.state.webLoaded" />
    <v-btn
      fab
      flat
      fixed
      bottom
      right
      @click="scrollTop"
    >
      <i
        class="fa flat fa-chevron-circle-up fa-3x"
        aria-hidden="true"
      ></i>
      <!-- <v-icon>add</v-icon> -->
    </v-btn>
  </v-container>
</template>
<style>
/* @import url('./assets/utils.css'); */
/* @import url('./assets/bootstrap.css'); */

.container.contenedor {
  max-width: 1170px !important;
}
.fade-enter-active {
  animation: slide-in 0.5s ease-out forwards;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity 0.3s;
  opacity: 0;
  animation: slide-out 0.3s ease-out forwards;
}

a.v-list__tile.v-list__tile--link.v-list__tile--avatar[data-v-f5bbe51e] {
  border: 1px dashed #ddd;
  cursor: move;
  margin-bottom: 10px;
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}

/* css de wp */
/* @import url('./assets/font-awesome.css'); */
/* @import url('./assets/style.css'); */
</style>
<script>
import { globales } from "./components/comunes";
import Cabecera from "@/components/plantilla/Cabecera.vue";
import Menu from "@/components/plantilla/Menu.vue";
import Pie from "@/components/plantilla/Footer.vue";
import Anuncio from "@/components/plantilla/Anuncio.vue";
import introPopup from "@/components/plantilla/IntroModal.vue";
import LanzarCookie from "@/components/Cookie";

import { cargarDatos } from "@/config/servicios";

// firebase parser
import FireStoreParser from "firestore-parser";
import axios from "axios";

const WEB_ID = "kutxabank.cms";
const REST_URL = `https://firestore.googleapis.com/v1beta1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/${WEB_ID}`;
const EVENTS_URL = `https://firestore.googleapis.com/v1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/kutxabank.cms/eventos`;

let LISTA_EVENTOS = [];

export default {
  mixins: [globales],
  components: {
    Cabecera,
    Menu,
    Pie,
    Anuncio,
    introPopup,
    LanzarCookie,
  },
  data() {
    return {
      componenteAnuncio: true,
      popup: false,
      webId: "kutxabank.cms",
    };
  },
  watch: {
    $route(to, from) {
      // console.log("nombre de la transisiont", this.tipoTransicion);
      this.tipoTransicion = "fade";
    },
  },
  created() {
    console.log('Version:', process.env.VUE_APP_VERSION);
    console.log('Build Date:', process.env.VUE_APP_BUILD_DATE);
    cargarDatos().then(doc => {
    // console.log("doc", doc);
      const { ahora, webItems, eventosJanto, datosWeb, recintosJanto } = doc;

      const eventosWeb = Object.keys(eventosJanto).map(key => {
        return eventosJanto[key];
      });

      this.$store.commit("setEventosWeb", eventosWeb);
      this.$store.commit("setEventosJanto", eventosJanto);
      this.$store.commit("setLayout", datosWeb);
      this.$store.commit("setItemsWeb", webItems);
      this.$store.commit("ahora", ahora);
      this.$store.commit("setCargando", false);
      this.$store.commit("setWebLoaded", true);
      this.$store.commit("setRecintosJanto", recintosJanto);

      // if ((secciones, pageLayout)) {
      //   const listaSecciones = Object.keys(secciones).map(key => {
      //     return secciones[key];
      //   });

      //   const top5 = listaSecciones.filter(
      //     seccion => seccion.configuracion.tipo === "top5"
      //   );

      //   console.log("top5", top5, listaSecciones);
      // }

      // commit("eventosJanto", eventosJantos);
    });
    const web = this.webId;

    const navigatorLang = window.navigator.language;
    let lang = "--";
    // axios
    //   .get(EVENTS_URL)
    //   .then(res => FireStoreParser(res.data))
    //   .then(json => {
    //     const eventosData = [];

    //     const documentData = json.documents;

    //     documentData.forEach(doc => {
    //       const grupo = doc.fields.eventos;
    //       grupo.forEach(evento => eventosData.push(evento));
    //     });

    //     LISTA_EVENTOS = eventosData;

    //     axios
    //       .get(REST_URL)
    //       .then(res => FireStoreParser(res.data))
    //       .then(json => {

    //         const webData = json.fields;

    //         webData.eventos = LISTA_EVENTOS;

    //         console.log("webData", webData);

    //       });
    //   });

    if (this.$cookie.get("lang")) {
      lang = this.$cookie.get("lang");
      this.$cookie.set("lang", lang, { expires: 7 });
    } else {
      lang = navigatorLang.split("-")[0];
    }

    const idioma = this.idiomas.includes(lang);

    if (idioma) {
      this.$i18n.locale = lang;
    }

    // console.log(
    //   "mounted locale",
    //   this.$i18n.locale,
    //   "cookie",
    //   this.$cookie.get("lang")
    // );
    // console.log("idioma", idioma, "navegador idioma", navigatorLang);
    // Firestore client
    // this.$store.dispatch("getLayout", web);
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
